import { Component } from "react";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import CircularProgress from "@material-ui/core/CircularProgress";

export default class TableCellPayoutActions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      cancelDialog: false,
    };
  }

  handleOpen = () => {
    this.setState({
      ...this.state,
      open: true,
    });
    let payout = this.props.getPayoutInfo();
    let payoutInfo = payout[this.props.item.Id];

    if (!payoutInfo || (!payoutInfo.fetching && !payoutInfo.fetched)) {
      this.props.getFinancingPayoutInfo(
        this.props.item.Id,
        this.props.item.LoanOffer,
        this.props.item.AssetType,
      );
    }
  };

  handleClose = () => {
    this.setState({
      ...this.state,
      open: false,
    });
  };

  openCancelDialog = () => {
    this.setState({
      ...this.state,
      cancelDialog: true,
    });
  };

  closeCancelDialog = () => {
    this.setState({
      ...this.state,
      cancelDialog: false,
    });
  };

  handleConfirm = () => {
    this.props.registerPayout(this.props.item.Id);
    this.handleClose();
  };

  handleCancelLoan = () => {
    this.props.cancelLoan(this.props.item.IntId);
    this.closeCancelDialog();
  };

  render() {
    const actions = [
      <Button
        id="registerConfirm"
        variant="outlined"
        color="primary"
        key="confirm"
        keyboardFocused={true}
        onClick={this.handleConfirm}
        disabled={this.props.item.PayoutInfoLoading}
      >
        Confirm
      </Button>,
      <Button
        key="close"
        variant="outlined"
        keyboardFocused={false}
        onClick={this.handleClose}
      >
        Close
      </Button>,
    ];

    let payoutInfo = this.props.getPayoutInfo(this.props.item.Id);
    let initFee =
      payoutInfo.data && payoutInfo.data.InitFee
        ? payoutInfo.data.InitFee.Amount
        : 0;

    return (
      <div className="table-cell-actions">
        <Button
          className="payoutButton"
          variant="contained"
          color="primary"
          onClick={this.handleOpen}
        >
          Payout
        </Button>
        <Dialog
          title="Register payout"
          modal={false}
          open={this.state.open}
          onClose={this.handleClose}
          autoScrollBodyContent={true}
        >
          <DialogContent>
            <div className="financing-payout">
              {payoutInfo.fetching ? (
                <CircularProgress />
              ) : payoutInfo.fetched ? (
                <div>
                  For Borrower: {payoutInfo.data.CreditAmount.Amount - initFee}{" "}
                  <br />
                  For Savelend: {initFee} <br />
                  Sum: {payoutInfo.data.CreditAmount.Amount} <hr />
                  Bank account: {payoutInfo.data.BankNumber.Number} <br />
                  Bank name: {payoutInfo.data.BankNumber.BankName} <br />
                  {payoutInfo.data.Name
                    ? "Name: " + payoutInfo.data.Name
                    : undefined}{" "}
                  <br />
                  {payoutInfo.data.SSN
                    ? "SSN: " + payoutInfo.data.SSN
                    : undefined}{" "}
                  <br />
                  {payoutInfo.data.Reference
                    ? "Reference: " + payoutInfo.data.Reference
                    : undefined}{" "}
                  <br />
                </div>
              ) : undefined}
            </div>
          </DialogContent>
          <DialogActions>{actions}</DialogActions>
        </Dialog>
        <Button
          variant="contained"
          color="primary"
          onClick={this.openCancelDialog}
        >
          Cancel
        </Button>
        <Dialog
          title="Cancel Loan"
          modal={false}
          open={this.state.cancelDialog}
          onClose={this.closeCancelDialog}
          autoScrollBodyContent={true}
        >
          <DialogContent>
            <div />
          </DialogContent>
          <DialogActions>
            <Button
              variant="outlined"
              color="primary"
              keyboardFocused={true}
              onClick={this.handleCancelLoan}
              disabled={this.props.item.PayoutInfoLoading}
            >
              Cancel Loan
            </Button>
            <Button
              variant="outlined"
              keyboardFocused={false}
              onClick={this.closeCancelDialog}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
